import { hover } from "@testing-library/user-event/dist/hover";
import React, { useEffect, useState } from "react";
import { searchObject } from "../firebase/fireQueries";
import useCreateModal from "../hooks/useCreateModal";
import useFirebaseSearch from "../hooks/useFirebaseSearch";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import useHover from "../hooks/useHover";
import useSearchLocally from "../hooks/useSearchLocally";
import ObjectListHolder from "../misc/elements/ObjectListHolder";
import {
  checkFoundSomething,
  forArrayLength,
  objectToArray,
} from "../misc/helperfuncs";
import MainStore from "../stores/MainStore";

const PickRelated = ({
  field,
  types,
  onObjectClicked,
  removedObject,
  holderWidth,
  selectedObjects,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const [foundStuff, setFoundStuff] = useState([]);
  const [searchEnabled, setSearchEnabled] = useState(false);
  const [foundSomething, setFoundSomething] = useState(false);
  const [createType, setCreateType] = useState("");
  const { getPluralType, getSingularType, getBoxType } = useHandleBoxTypes();

  useEffect(() => {
    if (removedObject) {
      if (field == removedObject.field) {
        const newFound = [...foundStuff];
        const foundKey = newFound.find(
          (kv) => kv.key == removedObject.object.collection
        );
        foundKey.value.push(removedObject.object);

        setFoundStuff(newFound);
        setFoundStuff(newFound);
      }
    }
  }, [removedObject]);

  useEffect(() => {
    const newFound = [...foundStuff];
    if (selectedObjects.length > 0) {
      forArrayLength(newFound, (found) => {
        found.value = found.value.filter((o) =>
          selectedObjects.some((so) => so.id != o.id)
        );
      });
    }
  }, [selectedObjects]);

  const createModal = useCreateModal({
    action: "Create",
    payload: { shortDescription: searchInput },
    onObjectCreated: onObjectClicked,
    type: createType,
  });

  function onCreateClicked(type) {
    setCreateType(type);
    createModal.open();
  }
  const fireHover = useHover(
    <div
      className="textBoldWhite"
      style={{
        backgroundColor: "#2f2f2f",
        padding: "2px",
        borderRadius: ".2rem/.2rem",
      }}
    >
      {`Search Online For ${types.join(" ")}`}
    </div>
  );

  function handleFoundResults(onlineResults) {
    const bothLists = foundStuff
      .find((kv) => kv.key == "open")
      .value.concat(foundStuff.find((kv) => kv.key == "saved").value);

    const filteredList = onlineResults.filter(
      (o) => bothLists.find((obj) => obj.id == o.id) == null
    );

    setFoundStuff([...foundStuff, { key: "online", value: filteredList }]);
  }

  function onFirebaseSearch(result) {
    const allResults = result.exact
      .concat(result.keywords)
      .concat(result.partially)
      .concat(result.categories);
    setFoundStuff([...foundStuff, { key: "online", value: allResults }]);
  }

  useFirebaseSearch({
    searchInput,
    type: "all",
    onSearched: onFirebaseSearch,
    searching: searchEnabled,
  });

  function searchOnline() {
    forArrayLength(types, (type) => {
      const bType = getBoxType(type);
      searchObject(searchInput, bType, handleFoundResults, false, null);
    });
  }

  function onSearchedLocally(result) {
    const noDuplicateResults = {
      ...result,
      saved: result.saved.filter(
        (o) => result.open.find((open) => open.id == o.id) == null
      ),
      general: result.general.filter(
        (o) => result.saved.find((saved) => saved.id == o.id) == null
      ),
    };

    const found = checkFoundSomething(result);

    setSearchEnabled(!found);
    setFoundSomething(found);
    setFoundStuff(objectToArray(noDuplicateResults));
  }

  useEffect(() => {
    if (searchInput.length < 4) {
      setSearchEnabled(false);
      setFoundStuff([]);
    }
  }, [searchInput]);

  useSearchLocally({
    input: searchInput,
    what: "all",
    onSearched: onSearchedLocally,
  });

  return (
    <div
      className="divColumn"
      style={{ justifyContent: "center", width: "100%" }}
    >
      <div
        className="divRow"
        style={{ width: "100%", justifyContent: "center" }}
      >
        <input
          value={searchInput}
          onChange={(e) =>
            setSearchInput(e.target.value.replace(/[^a-z\s]/gi, ""))
          }
          placeholder={`Find ${types}`}
          style={{
            fontFamily: "Roboto-Bold",
            marginTop: "5px",
            height: "20px",
            fontSize: "16px",
            backgroundColor: "#e3e3e3",
            textAlign: "center",
          }}
        />
        <div style={{ marginLeft: "5px" }}>
          {types.map((type) => (
            <CreateTypeButton
              key={type}
              type={type}
              onCreateClicked={onCreateClicked}
            />
          ))}
        </div>
        {searchInput.length > 3 && foundSomething && (
          <img
            onClick={searchOnline}
            style={{
              filter: !fireHover.hover ? "grayscale(100%)" : null,
              cursor: "pointer",
            }}
            src="/icons/icon_firebase.png"
            className="icon25"
            {...fireHover.divProps}
          />
        )}
        {fireHover.hoverDescription}
      </div>
      {foundStuff
        .filter((bar) => bar.value.length > 0)
        .map((bar) => (
          <SearchResultBar
            onObjectClicked={onObjectClicked}
            holderWidth={holderWidth}
            barName={bar.key}
            result={bar.value}
            key={bar.key}
            width={"100%"}
          />
        ))}

      {createModal.divs}
    </div>
  );
};

const CreateTypeButton = ({ type, onCreateClicked }) => {
  const { getPluralType, getSingularType } = useHandleBoxTypes();
  const hover = useHover();
  return (
    <div
      {...hover.divProps}
      style={{
        height: "100%",
        border: "2px solid #2a2a2a",
        padding: "2px",
        backgroundColor: "#4b4b4b",
      }}
      onClick={() => {
        onCreateClicked(getSingularType(type));
      }}
    >
      <div
        className="textBold"
        style={{ color: hover.hover ? "gold" : "#c3c3c3" }}
      >{`Create ${getSingularType(type)}`}</div>
    </div>
  );
};

const SearchResultBar = ({
  barName,
  result,
  width,
  holderWidth,
  onObjectClicked,
}) => {
  return (
    <div className="divColumn" style={{ width }}>
      <div
        className="textBoldWhite"
        style={{ color: "#363636", marginTop: "2px" }}
      >
        {barName}
      </div>
      <div
        className="divRow"
        style={{ width: "100%", justifyContent: "center" }}
      >
        {result.map((o, index) => (
          <ObjectListHolder
            object={o}
            width={holderWidth}
            onObjectClicked={onObjectClicked}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export default PickRelated;
